<template>
    <div>
        <b-row>

            <b-col lg="6">
                <b-form-group label="المنتدي">
                    <validation-provider name="forum" vid="forum" rules="required" v-slot="{ errors }">
                        <v-select v-model="newItem.code" :options="activitiesCodes ? activitiesCodes : []" class="w-100"
                            label="label" value-field="value" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="اسم المنتدي">
                    <validation-provider name="forum_name" vid="forum_name" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.forum_name" type="string"
                            :state="errors.length > 0 ? false : null" placeholder="اسم المنتدي" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="الثمرة التعليمية المستهدفة">
                    <validation-provider name="education_level" vid="education_level" rules="required"
                        v-slot="{ errors }">
                        <b-form-select v-model="newItem.education_level" :state="errors.length > 0 ? false : null"
                            :options="education_levels" />

                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="يمكن الوصول له من">
                    <validation-provider name="from" vid="from" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.from" type="datetime-local" :state="errors.length > 0 ? false : null"
                            placeholder="يمكن الوصل له من" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="يمكن الوصل له حتى">
                    <validation-provider name="to" vid="to" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.to" type="datetime-local" :state="errors.length > 0 ? false : null"
                            placeholder="يمكن الوصل له حتى" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
   
        <hr />
      
        <b-row>
            <b-col lg="6">
                <b-form-group label="حجم الملف">
                    <b-form-select v-model="newItem.file_size" :options="file_sizes" />
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="العدد الأقصي للملفات يمكن تحميلها  ">
                    <b-form-select v-model="newItem.max_files_allowed_count" :options="max_files_count" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="نوع التقييم">
                    <validation-provider name="rate_type" vid="rate_type" rules="required"
                        v-slot="{ errors }">
                        <b-form-select v-model="newItem.rate_type" :state="errors.length > 0 ? false : null"
                            :options="rate_types" />

                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
                <b-form-group label="الموضوع ">
                    <validation-provider name="subject" vid="subject" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.subject" type="string"
                            :state="errors.length > 0 ? false : null" placeholder=" الموضوع" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
                <b-form-group label="المناقشة">
                    <validation-provider name="discussion" vid="discussion" rules="required" v-slot="{ errors }">
                        <b-form-textarea v-model="newItem.discussion" :state="errors.length > 0 ? false : null"
                            placeholder="المناقشة" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
    props: ['newItem', 'activitiesCodes'],
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    data() {
        return {
            education_levels: [],
            homework_types: [],
            file_sizes: [],
            max_files_count: [],
            rate_types : []
        }
    },
    created() {
        // Education Levels
        let e = ["CLO1", "CLO2", "CLO3"];
        this.education_levels = e.map((val) => {
            return val;
        });
        // File Sizes
        let f = ["5MB", "2MB", "1MB", "500KB", "100KB", "50KB", "10KB"];
        this.file_sizes = f.map((val) => {
            return val;
        });
        // Max Files Count
        let m = ["1", "2", "3", "4", "5"];
        this.max_files_count = m.map((val) => {
            return val;
        });
        // Rate Types
        let x = ['الحد الأقصي للتقييمات', 'متوسط التقييمات']
        this.rate_types =  x.map((val) => {
            return val;
        });
    }
}

</script>